module.exports = __webpack_public_path__ + "img/web-maju-jaya-group.b7ed8d31.jpg";